import { render, staticRenderFns } from "./frontListaRecientes.vue?vue&type=template&id=64ef206a&scoped=true&"
import script from "./frontListaRecientes.vue?vue&type=script&lang=js&"
export * from "./frontListaRecientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef206a",
  null
  
)

export default component.exports